
// import { useState, useEffect } from "react";
// import { useParams, useSearchParams, useNavigate } from "react-router-dom";
// import { Container, Row, Col, Nav, Button } from "react-bootstrap";
// import IntendedLearners from "./intended-learners";
// import CourseStructure from "./course-structure";
// import SetupVideo from "./setup-video";
// import FilmEdit from "./film-edit";
// import Curriculum from "./curriculum";
// import CourseLandingPage from "./course-landing-page";
// import CourseMessages from "./course-messages";
// import Header from "../Header";
// import { FaArrowLeft } from "react-icons/fa";

// export default function AddCourseInfo() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const initialView = searchParams.get("view") || "intended-learners";
//   const [currentView, setCurrentView] = useState(initialView);

//   useEffect(() => {
//     setCurrentView(initialView);
//   }, [initialView]);

//   const renderView = () => {
//     switch (currentView) {
//       case "intended-learners":
//         return <IntendedLearners courseId={id} />;
//       case "course-structure":
//         return <CourseStructure courseId={id} />;
//       case "setup-video":
//         return <SetupVideo courseId={id} />;
//       case "film-edit":
//         return <FilmEdit courseId={id} />;
//       case "curriculum":
//         return <Curriculum courseId={id} />;
//       case "courselandingpage":
//         return <CourseLandingPage courseId={id} />;
//       case "course-messages":
//         return <CourseMessages courseId={id} />;
//       default:
//         return <IntendedLearners courseId={id} />;
//     }
//   };

//   const sidebarStyle = {
//     background: "linear-gradient(145deg, #a1c4fd, #c2e9fb)",
//     padding: "25px 15px",
//     borderRadius: "15px",
//     minHeight: "100vh",
//     color: "#002b5b",
//     fontFamily: "Segoe UI, sans-serif",
//     transition: "all 0.3s ease-in-out",
//   };

//   const navLinkStyle = (isActive) => ({
//     padding: "10px 15px",
//     margin: "5px 0",
//     borderRadius: "10px",
//     backgroundColor: isActive ? "#007bff" : "transparent",
//     color: isActive ? "#fff" : "#003366",
//     fontWeight: isActive ? "600" : "500",
//     cursor: "pointer",
//     transition: "0.3s",
//     textDecoration: "none",
//   });

//   const mainContentStyle = {
//     padding: "25px",
//     backgroundColor: "#f8f9fc",
//     borderRadius: "15px",
//     marginTop: "70px",
//   };

//   const submitBtnStyle = {
//     background: "linear-gradient(90deg, #667eea, #764ba2)",
//     border: "none",
//     padding: "12px 25px",
//     fontSize: "16px",
//     borderRadius: "30px",
//     color: "#fff",
//     fontWeight: "bold",
//     transition: "transform 0.3s",
//   };

//   const submitBtnHover = {
//     transform: "scale(1.05)",
//   };

//   return (
//     <Container fluid>
//       <Header />
//       <Row style={mainContentStyle}>
//         {/* Sidebar Navigation */}
//         <Col
//           md={3}
//           style={sidebarStyle}
//           className="d-flex flex-column align-items-start"
//         >
//           <Nav className="flex-column w-100">
//             <div className="mb-4 w-100">
//               <h6 className="text-dark mb-3">🚀 Plan your course</h6>
//               <Nav.Link
//                 style={navLinkStyle(currentView === "intended-learners")}
//                 onClick={() => setCurrentView("intended-learners")}
//               >
//                 🎯 Intended learners
//               </Nav.Link>
//               <Nav.Link
//                 style={navLinkStyle(currentView === "course-structure")}
//                 onClick={() => setCurrentView("course-structure")}
//               >
//                 🧩 Course structure
//               </Nav.Link>
//               <Nav.Link
//                 style={navLinkStyle(currentView === "setup-video")}
//                 onClick={() => setCurrentView("setup-video")}
//               >
//                 🎥 Setup & test video
//               </Nav.Link>
//             </div>

//             <div className="mb-4 w-100">
//               <h6 className="text-dark mb-3">🎬 Create your content</h6>
//               <Nav.Link
//                 style={navLinkStyle(currentView === "film-edit")}
//                 onClick={() => setCurrentView("film-edit")}
//               >
//                 🎞️ Film & edit
//               </Nav.Link>
//               <Nav.Link
//                 style={navLinkStyle(currentView === "curriculum")}
//                 onClick={() => setCurrentView("curriculum")}
//               >
//                 📚 Curriculum
//               </Nav.Link>
//             </div>

//             <div className="mb-4 w-100">
//               <h6 className="text-dark mb-3">📢 Publish your course</h6>
//               <Nav.Link
//                 style={navLinkStyle(currentView === "courselandingpage")}
//                 onClick={() => setCurrentView("courselandingpage")}
//               >
//                 🌐 Course landing page
//               </Nav.Link>
//               <Nav.Link
//                 style={navLinkStyle(currentView === "course-messages")}
//                 onClick={() => setCurrentView("course-messages")}
//               >
//                 💬 Course messages
//               </Nav.Link>
//             </div>

//             <div className="mt-4 text-center w-100">
//               <Button
//                 style={submitBtnStyle}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.transform = "scale(1.05)")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.transform = "scale(1)")
//                 }
//                 onClick={() => navigate(`/course/${id}`)}
//               >
//                 🚀 Submit
//               </Button>
//             </div>
//           </Nav>
//         </Col>

//         {/* Main Content */}
//         <Col md={9} style={{ padding: "10px" }}>
//           {renderView()}
//         </Col>
//       </Row>
//     </Container>
//   );
// }


import { useState, useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Container, Nav, Button } from "react-bootstrap";
import IntendedLearners from "./intended-learners";
import CourseStructure from "./course-structure";
import SetupVideo from "./setup-video";
import FilmEdit from "./film-edit";
import Curriculum from "./curriculum";
import CourseLandingPage from "./course-landing-page";
import CourseMessages from "./course-messages";
import Header from "../Header";

export default function AddCourseInfo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialView = searchParams.get("view") || "intended-learners";
  const [currentView, setCurrentView] = useState(initialView);

  useEffect(() => {
    setCurrentView(initialView);
  }, [initialView]);

  const renderView = () => {
    switch (currentView) {
      case "intended-learners":
        return <IntendedLearners courseId={id} />;
      case "course-structure":
        return <CourseStructure courseId={id} />;
      case "setup-video":
        return <SetupVideo courseId={id} />;
      case "film-edit":
        return <FilmEdit courseId={id} />;
      case "curriculum":
        return <Curriculum courseId={id} />;
      case "courselandingpage":
        return <CourseLandingPage courseId={id} />;
      case "course-messages":
        return <CourseMessages courseId={id} />;
      default:
        return <IntendedLearners courseId={id} />;
    }
  };

  const headerHeight = 70;

  const sidebarStyle = {
    width: "256px",
    backgroundColor: "#F97316",
    padding: "30px 20px",
    height: `calc(100vh - ${headerHeight}px)`,
    color: "#fff",
    position: "fixed",
    top: `${headerHeight}px`, // 👈 below header
    left: 0,
    overflowY: "auto",
  };

  const navLinkStyle = (isActive) => ({
    padding: "10px 15px",
    borderRadius: "8px",
    margin: "8px 0",
    backgroundColor: isActive ? "#fff" : "transparent",
    color: isActive ? "#000" : "#fff",
    fontWeight: isActive ? "600" : "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "block",
    textDecoration: "none",
  });

  const sectionHeaderStyle = {
    fontSize: "14px",
    fontWeight: "bold",
    letterSpacing: "1px",
    textTransform: "uppercase",
    margin: "30px 0 10px",
    borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
    paddingBottom: "4px",
  };

  const mainContentStyle = {
    marginLeft: "256px", // leave space for sidebar
    padding: "30px",
    paddingTop: `${headerHeight + 20}px`, // 👈 below header
    backgroundColor: "#f8f9fc",
    minHeight: "100vh",
  };

  const submitBtnStyle = {
    background: "#fff",
    border: "none",
    padding: "12px 25px",
    fontSize: "16px",
    borderRadius: "30px",
    color: "#F97316",
    fontWeight: "bold",
    transition: "transform 0.3s",
    width: "100%",
  };

  return (
    <div>
      <Header />
      <div style={sidebarStyle}>
        <Nav className="flex-column w-100">
          <div>
            <div style={sectionHeaderStyle}>Plan your course</div>
            <Nav.Link
              style={navLinkStyle(currentView === "intended-learners")}
              onClick={() => setCurrentView("intended-learners")}
            >
              Intended learners
            </Nav.Link>
            <Nav.Link
              style={navLinkStyle(currentView === "course-structure")}
              onClick={() => setCurrentView("course-structure")}
            >
              Course structure
            </Nav.Link>
            <Nav.Link
              style={navLinkStyle(currentView === "setup-video")}
              onClick={() => setCurrentView("setup-video")}
            >
              Setup & test video
            </Nav.Link>
          </div>

          <div>
            <div style={sectionHeaderStyle}>Create your content</div>
            <Nav.Link
              style={navLinkStyle(currentView === "film-edit")}
              onClick={() => setCurrentView("film-edit")}
            >
              Film & edit
            </Nav.Link>
            <Nav.Link
              style={navLinkStyle(currentView === "curriculum")}
              onClick={() => setCurrentView("curriculum")}
            >
              Curriculum
            </Nav.Link>
          </div>

          <div>
            <div style={sectionHeaderStyle}>Publish your course</div>
            <Nav.Link
              style={navLinkStyle(currentView === "courselandingpage")}
              onClick={() => setCurrentView("courselandingpage")}
            >
              Course landing page
            </Nav.Link>
            <Nav.Link
              style={navLinkStyle(currentView === "course-messages")}
              onClick={() => setCurrentView("course-messages")}
            >
              Course messages
            </Nav.Link>
          </div>

          <div style={{ marginTop: "30px" }}>
            <Button
              style={submitBtnStyle}
              onClick={() => navigate(`/course/${id}`)}
            >
              Submit
            </Button>
          </div>
        </Nav>
      </div>

      <div style={mainContentStyle}>{renderView()}</div>
    </div>
  );
}
